import api from "./api";
export const getRealTimeMail = async (params) => {
  return await api.post("/api/linkbuilder_user/get_mails", params );
};
